<template>
  <span class="hidden" aria-hidden="true"></span>
</template>

<script>
import stFrancisCertificate from '@/assets/images/St_Francis_Certificate_of_Donation.png';

export default {
  name: 'StFrancisDonorCertificate',
  props: {
    donor: {
      type: Object,
      required: true,
    },
  },
  methods: {
    escapeCertificateText(value) {
      return String(value ?? '').replace(/[&<>"']/g, (character) => ({
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;',
      }[character]));
    },
    signatureDataUrl(signature) {
      if (!signature || !Array.isArray(signature.strokes) || signature.strokes.length === 0) return '';

      const canvas = document.createElement('canvas');
      canvas.width = 900;
      canvas.height = 220;
      const context = canvas.getContext('2d');
      context.strokeStyle = '#111827';
      context.lineWidth = 3;
      context.lineCap = 'round';
      context.lineJoin = 'round';

      signature.strokes.forEach((stroke) => {
        if (!Array.isArray(stroke.points) || stroke.points.length === 0) return;
        context.beginPath();
        context.moveTo(stroke.points[0].x * canvas.width, stroke.points[0].y * canvas.height);
        stroke.points.slice(1).forEach((point) => context.lineTo(point.x * canvas.width, point.y * canvas.height));
        if (stroke.points.length === 1) {
          context.lineTo(stroke.points[0].x * canvas.width + 1, stroke.points[0].y * canvas.height);
        }
        context.stroke();
      });

      return canvas.toDataURL('image/png');
    },
    printStFrancisDonorCertificate() {
      const donation = this.donor.blood_donation
        || [...(this.donor.blood_donations || [])].sort((a, b) => new Date(b.date_added) - new Date(a.date_added))[0]
        || {};
      const donorUser = this.donor.user || this.donor.users || {};
      const donorName = [donorUser.first_name, donorUser.middle_name, donorUser.last_name].filter(Boolean).join(' ');
      const bloodGroup = donorUser.blood_group_id?.description || donorUser.blood_group_id?.name || '';
      const donationDate = donation.date_added ? new Date(donation.date_added).toLocaleDateString('en-GB') : '';
      const nextDonationDate = donation.next_donation_date ? new Date(donation.next_donation_date).toLocaleDateString('en-GB') : '';
      const donorSignature = this.donor.declaration?.signature_url || '';
      const labTechSignature = this.signatureDataUrl(donation.approved_by?.users?.signature);
      const printWindow = document.createElement('iframe');
      printWindow.style.position = 'fixed';
      printWindow.style.width = '0';
      printWindow.style.height = '0';
      printWindow.style.border = '0';
      document.body.appendChild(printWindow);

      const printDocument = `
        <!doctype html>
        <html>
          <head>
            <title>St Francis Donor Certificate</title>
            <link href="https://fonts.googleapis.com/css2?family=Dancing+Script:wght@400;700&display=swap" rel="stylesheet">
            <style>
              @page { size: A4 landscape; margin: 0; }
              * { box-sizing: border-box; }
              html, body { margin: 0; width: 100%; height: 100%; }
              .certificate { position: relative; width: 100vw; height: 100vh; overflow: hidden; }
              .background { position: absolute; inset: 0; width: 100%; height: 100%; object-fit: fill; }
              .text, .signature { position: absolute; transform: translate(-50%, -50%); }
              .text { color: #555; font-family: 'Dancing Script', cursive; font-weight: bold; text-align: center; white-space: nowrap; }
              .donor-name { left: 50%; top: 47.8%; width: 70%; font-size: 24pt; }
              .blood-group { left: 50%; top: 55.8%; font-size: 18pt; }
              .donation-date { left: 31.6%; top: 64.6%; font-size: 18pt; }
              .next-date { left: 68.4%; top: 64.6%; font-size: 18pt; }
              .signature { top: 77%; width: 18.5%; height: 6.3%; object-fit: contain; }
              .donor-signature { left: 31.2%; top: 75%; }
              .lab-signature { left: 69%; }
              @media print {
                html, body, .certificate { width: 297mm; height: 210mm; }
                .background { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
              }
            </style>
          </head>
          <body>
            <main class="certificate">
              <img class="background" src="${stFrancisCertificate}" alt="St Francis certificate background">
              <div class="text donor-name">${this.escapeCertificateText(donorName)}</div>
              <div class="text blood-group">${this.escapeCertificateText(bloodGroup)}</div>
              <div class="text donation-date">${this.escapeCertificateText(donationDate)}</div>
              <div class="text next-date">${this.escapeCertificateText(nextDonationDate)}</div>
              ${donorSignature ? `<img class="signature donor-signature" src="${this.escapeCertificateText(donorSignature)}" alt="Donor signature">` : ''}
              ${labTechSignature ? `<img class="signature lab-signature" src="${labTechSignature}" alt="Lab technician signature">` : ''}
            </main>
          </body>
        </html>`;

      printWindow.onload = () => {
        setTimeout(() => {
          printWindow.contentWindow.print();
          setTimeout(() => document.body.removeChild(printWindow), 1000);
        }, 300);
      };
      printWindow.contentDocument.open();
      printWindow.contentDocument.write(printDocument);
      printWindow.contentDocument.close();
    },
  },
};
</script>
